import styled from 'styled-components';
import Button from 'components/Button';

const PrintButton = styled(Button)`
  padding: 0.5em 1em;
  font-size: 0.6em;
  float: right;
`;

export default PrintButton;
